import React from "react";
import Styles from "./Reviews.module.css";
import ReviewCard from "./ReviewCard";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import guideDataEN from "../../../../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../../../../i18n/translations/GuideData/GuideDataAr";
import guideDataKu from '../../../../i18n/translations/GuideData/GuideDataKu'

function Reviews() {

	const { t, i18n } = useTranslation();
	const { id } = useParams();

	const currentLanguage = i18n.language;
	const guideData =
		currentLanguage === "en"
			? guideDataEN
			: currentLanguage === "ar"
			? guideDataAr
			: guideDataKu;

	const guide = guideData.filter(
		(guide) => guide.idGuide.toString() === id.toString()
	)[0];

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	return (
		<div>
			<h2
				className={Styles.h2}
				dir={isRtl ? "rtl" : "ltr"}
			>
				{t("GuideProfile.reviews")}
			</h2>
			<Marquee
				speed={120}
				loop={0}
				pauseOnHover
			>
				<div className={Styles.reviewsGrid}>
					{guide.UsersReviews.map((UserReview) => (
						<div key={UserReview.userId}>
							<ReviewCard
								userName={UserReview.userName}
								userGuideRate={UserReview.userGuideRate}
								comment={UserReview.comment}
							/>
						</div>
					))}
				</div>
			</Marquee>
		</div>
	);
}

export default Reviews;
